export default {
  apiUrl: 'https://api.s.gymcloud.com',
  wsUrl: 'wss://api.s.gymcloud.com/cable',
  facebook: {
    app_id: '1457484574486556',
    pixel_id: '116010479055307',
  },
  google: {
    client_id: '686822539338-h8pp1erjru867em1h45f7rf0qe0ftpdf.apps.googleusercontent.com',
  },
  urls: {
    landing: 'https://www.gymcloud.com',
    support: 'http://support.gymcloud.com/support/home',
    freshdesk: 'https://gymcloud.freshdesk.com/support/home',
  },
  sentry: {
    dsn: 'https://81fad452a5d2403ea9d79e9ec98e440d@sentry.gymcloud.com/11',
  },
  mixpanel: {
    token: '336eb91f2985286a562f6dc9aaf50cb9',
  },
  stripe: {
    key: 'pk_test_RpzCn9JnCXAjKRdZU19MzaTL',
    client_id: 'ca_FH0PgqpEQ3ELeyIxic4D7UkHy0ay8KG7',
  },
  mobile: {
    app: 'gymcloud://',
    url: 'https://mobile.gymcloud.com',
    app_store_url: 'https://itunes.apple.com/qa/app/gymcloud/id1004581098',
    google_play_url: 'https://play.google.com/store/apps/details?id=com.gymcloud.mobile',
  },
};
